import React from 'react'

import { BrandAssetsListingStyled, BrandAssetsListingItemStyled } from './styles'
import BrandAssetBox from './../../molecules/BrandAssetBox'
import { BrandAssetsListingProps } from './types'

const BrandAssetsListing: React.FC<BrandAssetsListingProps> = ({ data }) => {
  return (
    <BrandAssetsListingStyled>
      {data &&
        data.map((el) => (
          <BrandAssetsListingItemStyled key={el.key}>
            <BrandAssetBox data={el} />
          </BrandAssetsListingItemStyled>
        ))}
    </BrandAssetsListingStyled>
  )
}

export default BrandAssetsListing
